const Logo = () => (
  <div className="layout-logo">
    <img alt="Logo" src="/assets/logo.svg" />
  </div>
);

export default Logo;
